import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';
import DropdownComponent from "./DropdownComponent";
import SizeTableSwitcherComponent from "./SizeTableSwitcherComponent";

export default class PdpExtendedComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-addtocart'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    let elem = document.querySelector('.jsToBagBtn');
    let pdpElement = document.querySelector('.c-pdp-main');
    if(elem != null) {
      const sku = pdpElement.getAttribute('data-product-code');
      doAjax({
          type: 'POST',
          url: '/action/ajax/specialpdpcheck',
          data: {
            sku: sku
          }
        })
        .done(resp => {
          if(resp) {
            doAjax({
                type: 'POST',
                url: '/action/ajax/specialpdp',
                data: {
                  sku: sku
                }
              })
              .done(resp => {
                $('.js-editorial-content').append($(resp).find('#pdp-editorial'));
                this.$emit(this.$customEvents.CAROUSEL.triggerCarousel);
              })
              .fail(xhr => {
                this.log('Related page not found');
              })
              .always((xhr) => {

              });
          }
        })
        .fail(xhr => {
          this.log('Related page not found');
        })
        .always((xhr) => {

        });
    }
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, (e) => {
      this.vexComponentLoader();
    });
  }

  vexComponentLoader() {
    if (!document.body.classList.contains('vex-components-loaded')) {
      this.DropdownComponent = new DropdownComponent();
      this.SizeTableSwitcherComponent = new SizeTableSwitcherComponent();
      this.DropdownComponent.render();
      this.SizeTableSwitcherComponent.render();
      document.body.classList.add('vex-components-loaded');
    }
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }

}
